import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {Card, CardBody, Col, Container, Row } from 'reactstrap';
import EntrataRewardsDataTable from './components/EntrataRewardsDataTable';

const EntrataRewardsIndex = ({}) => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Entrata Rewards Data</h3>
          <h3 class="page-subhead subhead"><Link className="" to="/">Home</Link> / Entrata Rewards Data</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
            <Card>
                <CardBody>
                  <EntrataRewardsDataTable  />
                </CardBody>
            </Card>
        </Col>
      </Row>
    </Container>
)}

export default EntrataRewardsIndex;
